import kebabCase from 'lodash/kebabCase';
import { PUBLIC_PATHS } from '../config/constants';

export const isPublicPath = (pathname: string) => (
  // Routes match case-insensitively, so "/Login" is the login page too
  PUBLIC_PATHS.includes(pathname.toLowerCase().replace(/\/+$/, '') || '/')
);

export const getProjectIdFromUrl = () => {
  const pathArray = window.location.pathname.split('/');
  const projectSlug = pathArray[1];
  if (!projectSlug) return undefined;
  const parts = projectSlug.split('-');
  const projectId = parts[parts.length - 1];

  if (!projectId.match(/^[0-9a-fA-F]{24}$/)) return undefined;
  return projectId;
};

export const generateProjectSlug = (name: string, id: string) => `${kebabCase(name)}-${id}`;
